import Settings from '../../settings'
import extractSecretKey from '../../data_management/extractSecretKey'

const LogoUploader = function ($scope, $element, initialDataInteractor, brandingInteractor, uiUploader, eventsService) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    document.getElementById('logoField').onchange = function (event) {
      let target = event.target || window.event.srcElement, files = target.files;

      if (FileReader && files && files.length) {
        if (isFileValid(files[ 0 ])) {
          let fileReader = new FileReader();
          fileReader.onload = function () {
            document.getElementById('selectedLogo').src = fileReader.result;
          };
          fileReader.readAsDataURL(files[ 0 ]);
        } else {
          document.getElementById('logoField').value = '';
        }
      }
    };

    setCurrentLogoUrl();
  };


  $ctrl.uploadLogo = function () {
    $ctrl.chosenImage = document.getElementById('logoField').files;
    if ($ctrl.chosenImage) {
      uiUploader.addFiles($ctrl.chosenImage);
      uiUploader.startUpload({
        url: Settings.serviceUrl + '/api/v1/coach/branding/logo',
        withCredentials: true,
        customHeaders: [ [ 'X-Auth-Token', extractSecretKey(initialDataInteractor) ] ],
        onCompleted: () => {
          eventsService.publishSystemMessage('Logo successfully uploaded');
          uiUploader.removeAll();
          setLogoDisplays();
        }
      })
    }
  };

  function setCurrentLogoUrl() {
    brandingInteractor.getCurrentLogoUrl().then(url => {
      $ctrl.currentLogoUrl = url;
      $scope.$digest();
    })
  }

  function setLogoDisplays() {
    document.getElementById('logoField').value = '';
    document.getElementById('selectedLogo').src = '';
    setCurrentLogoUrl();
    $scope.$digest();
  }

  function isFileValid(file) {
    if (file.type != 'image/svg+xml') {
      eventsService.publishSystemError('File must an SVG image');
      return false;
    }
    return true;
  }
};

export default {
  name: 'logoUploader',
  obj: {
    controller: LogoUploader,
    templateUrl: 'components/logo_uploader.html'
  },
  deps: []
}